export type AnalyticsParams = Record<
  string,
  string | number | boolean | null | undefined
>

type DataLayerWindow = Window & { dataLayer?: Record<string, unknown>[] }

// GTM merges every push into one data model and keeps a key until something
// overwrites it, so a parameter from an earlier event would otherwise be read
// by the tag of a later event that doesn't set it. Each push therefore clears
// the keys earlier events set, and GA4 drops the parameters left undefined.
const pushedKeys = new Set<string>()

export function trackEvent(event: string, params: AnalyticsParams = {}) {
  if (!import.meta.client) return

  const cleared: AnalyticsParams = {}
  for (const key of pushedKeys) {
    if (!(key in params)) cleared[key] = undefined
  }
  for (const key of Object.keys(params)) pushedKeys.add(key)

  const w = window as DataLayerWindow
  w.dataLayer ??= []
  w.dataLayer.push({ event, ...cleared, ...params })
}
